export default __webpack_public_path__ + "static/media/CapaFile.6babb2ac.svg";